import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { EventSidepanelNavigationDocument, SessionFragment } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

type Sidepanels = 'attendance' | 'editSession'

const EventSidepanelNavigation = ({ sidepanel }: { sidepanel: Sidepanels }) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id, classId, eventId } = useParams()
  const { data, loading } = useQuery(EventSidepanelNavigationDocument, {
    variables: { trainingClassIds: [String(classId)] },
  })

  if (loading) return <></>

  const currentEvent = data?.trainings.sessionsConnection.nodes.find(
    (session) => session.id === Number(eventId)
  )

  if (!currentEvent || !data) {
    navigate(
      navigation.trainings.list.details_revamp.view.trainingClasses.detail.sessions.fullPath({
        id: String(id),
        classId: String(classId),
      })
    )

    return
  }

  return (
    <Sidepanel
      width="wide"
      open
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.trainingClasses.detail.sessions.fullPath({
            id: String(id),
            classId: String(classId),
          })
        )
      }
      title={
        <Header
          currentEvent={currentEvent}
          events={data.trainings.sessionsConnection.nodes}
          sidepanel={sidepanel}
        />
      }
    >
      <Outlet />
    </Sidepanel>
  )
}

const Header = ({
  currentEvent,
  events,
  sidepanel,
}: {
  currentEvent: SessionFragment
  events: SessionFragment[]
  sidepanel: Sidepanels
}) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id, classId } = useParams()
  const clampIndex = (index: number) => {
    if (index < 0) return events[events.length - 1]?.id
    if (index >= events.length) return events[0]?.id

    return events[index]?.id
  }
  const prevEvent = clampIndex(events.indexOf(currentEvent) - 1)
  const nextEvent = clampIndex(events.indexOf(currentEvent) + 1)

  const getNavigation = (eventId: number) => {
    if (sidepanel === 'attendance') {
      return navigation.trainings.list.details_revamp.view.trainingClasses.detail.sessions.attendance.event.fullPath(
        { id: String(id), classId: String(classId), eventId: String(eventId) }
      )
    }

    // put session edit mode here
    return navigation.trainings.list.details_revamp.view.trainingClasses.detail.sessions.attendance.event.fullPath(
      { id: String(id), classId: String(classId), eventId: String(eventId) }
    )
  }
  return (
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s24">
      {events.length > 1 && (
        <Box onClick={() => navigate(getNavigation(Number(prevEvent)))}>
          <Icon.Small color="grey1000" icon="chevron-left" />
        </Box>
      )}
      <Text size="200" weight="medium" color="grey1000">
        {currentEvent.name}
      </Text>
      {events.length > 1 && (
        <Box onClick={() => navigate(getNavigation(Number(nextEvent)))}>
          <Icon.Small color="grey1000" icon="chevron-right" />
        </Box>
      )}
    </Box>
  )
}

export default EventSidepanelNavigation
